import axios from "axios";
import { getFilenameFromDisposition } from "./getFileName";

 const downloadFile = async (url) => {
  if (!url) return;

  try {
    const response = await axios.get(url, { responseType: 'arraybuffer' });

    const fileName = getFilenameFromDisposition(response.headers['content-disposition']);
    const blob = new Blob([response.data], { type: 'application/zip' });
    const objectUrl = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = fileName;
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(objectUrl);
  } catch (error) {
    window.open(url, '_blank');
  }
};
export default  downloadFile;
